import {
  reactQueryDelete,
  reactQueryGet,
  reactQueryPost,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import type {
  AccessGroupType,
  PaginatedAccessGroupsResponse,
} from "@/react/types/AccessGroup";
import { internalApi } from "@circle-react/helpers/urlHelpers";

export interface AccessGroupParamsType {
  description: string;
  name: string;
}

export interface IdResponseData {
  id: number;
}

export interface UpdateAccessGroupParams {
  id: number;
  params: AccessGroupParamsType;
}

export const accessGroupsApi = () => {
  const listAccessGroups = ({ params = {} }) =>
    reactQueryGet<PaginatedAccessGroupsResponse>(
      internalApi.admin.accessGroups.index({ params }),
    );

  const createAccessGroup = (params: AccessGroupParamsType) =>
    reactQueryPost<AccessGroupType>(
      internalApi.admin.accessGroups.create(),
      params,
    );

  const updateAccessGroup = ({ id, params }: UpdateAccessGroupParams) =>
    reactQueryPut<IdResponseData, AccessGroupParamsType>(
      internalApi.admin.accessGroups.update(id),
      params,
    );

  const showAccessGroup = (id: number) =>
    reactQueryGet<AccessGroupType>(internalApi.admin.accessGroups.show(id));

  const destroyAccessGroup = (id: number) =>
    reactQueryDelete<unknown, object>(
      internalApi.admin.accessGroups.delete(id),
    );

  const unarchiveAccessGroup = (id: number) =>
    reactQueryPut<IdResponseData, object>(
      internalApi.admin.accessGroups.unarchive(id),
    );

  return {
    listAccessGroups,
    createAccessGroup,
    showAccessGroup,
    updateAccessGroup,
    destroyAccessGroup,
    unarchiveAccessGroup,
  };
};
